<template>
  <div class="relative">
    <DataGetter
      @dataAvailable="
        data => {
          rawStats = data?.metaData
        }
      "
      contentId="stats"
    />
    <div>
      <div
        class="w-min flex bg-slate-100 overflow-hidden divide-x rounded-lg shadow border whitespace-nowrap items-center"
      >
        <button
          class="px-4 py-2 font-bold"
          :class="{ 'bg-primary text-white': showedStats=='initiated' }"
          @click="showedStats = 'initiated'"
        >
          Initié
        </button>
        <button
          class="px-4 py-2 font-bold"
          :class="{ 'bg-primary text-white': showedStats=='done' }"
          @click="showedStats = 'done'"
        >
          Réussi
        </button>
        <button
          class="px-4 py-2 font-bold"
          :class="{ 'bg-primary text-white': showedStats=='failed' }"
          @click="showedStats = 'failed'"
        >
          Echoué
        </button>
      </div>
    </div>
    <div class="relative flex justify-center">
      <div
        class="pointer-events-none absolute bottom-[80%] bg-white px-4 py-2 border rounded-xl shadow-b-2xl z-[2] whitespace-nowrap text-center duration-300"
        :class="{
          'translate-y-1/2 opacity-0 ': !statDetail.isVisible,
          'translate-y-0 opacity-100': statDetail.isVisible,
        }"
      >
        <div>{{ statDetail.title }}</div>
        <div
          class="font-bold text-lg text-[#cbced8]"
          v-if="showedStats == 'initiated'"
        >
          {{ statsValues.initiated[statDetail.position] || 0 }} Initiée
        </div>
        <div
          class="font-bold text-lg text-[#4368FA]"
          v-if="showedStats == 'done'"
        >
          {{ statsValues.done[statDetail.position] || 0 }} Réussies
        </div>
        <div
          class="font-bold text-lg text-[#FF7752]"
          v-if="showedStats == 'failed'"
        >
          {{ statsValues.failed[statDetail.position] || 0 }} Echouées
        </div>
      </div>
      <div class="w-full h-[20vh]">
        <RawStats
          v-if="showedStats == 'initiated'"
          class="absolute w-full h-full [&_.statLine]:!stroke-[#cbced8] [&_.statDot]:!fill-[#cbced8]"
          :maxValue="maxValue"
          :stats="statsValues.initiated"
          @hoveredStatPoint="showStatDetail"
          @outFromStatPoint="hideStatDetail"
        />
        <RawStats
          v-if="showedStats == 'failed'"
          class="absolute w-full h-full [&_.statLine]:!stroke-[#FF7752] [&_.statDot]:!fill-[#FF7752]"
          :maxValue="maxValue"
          :stats="statsValues.failed"
          @hoveredStatPoint="showStatDetail"
          @outFromStatPoint="hideStatDetail"
        />
        <RawStats
          v-if="showedStats == 'done'"
          class="absolute w-full h-full [&_.statLine]:!stroke-[#4368FA] [&_.statDot]:!fill-[#4368FA]"
          :maxValue="maxValue"
          :stats="statsValues.done"
          @hoveredStatPoint="showStatDetail"
          @outFromStatPoint="hideStatDetail"
        />
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue'
import DropdownComponent from '@/components/utils/DropdownComponent.vue'
import RawStats from './RawStats.vue'
import DataGetter from '../utils/DataGetter.vue'

export default defineComponent({
  name: 'PlatformStats',
  components: { DropdownComponent, RawStats, DataGetter },
  props: {
    title: {
      type: String,
      default: '',
    },
    unit: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      rawStats: [],
      statDetail: {
        isVisible: false,
        title: 'Details',
        position: 0,
      },
      showedStats: 'done',
    }
  },
  mounted() {},
  methods: {
    selectPeriod(period) {
      this.selectedPeriod = period.id
    },
    showStatDetail({ value, position }) {
      const statData = this.stats.initiated[position]
      // const days = [
      //   'Lundi',
      //   'Mardi',
      //   'Mercredi',
      //   'Jeudi',
      //   'Vendredi',
      //   'Samedi',
      //   'Dimanche',
      // ]
      // const dates = new Array(this.statsValues.length)
      //   .fill('')
      //   .map((el, i) => `Date: ${i}`)
      // const month = [
      //   'Janvier',
      //   'Février',
      //   'Mars',
      //   'Avril',
      //   'Mai',
      //   'Juin',
      //   'Juillet',
      //   'Aout',
      //   'Septembre',
      //   'Octobre',
      //   'Novembre',
      //   'Décembre',
      // ]
      // const titles = {
      //   week: days,
      //   previousWeek: days,
      //   month: dates,
      //   year: month,
      // }
      this.statDetail.title = statData?.title || ''
      // this.statDetail.value = statData.detail || statData.value
      this.statDetail.position = position
      this.statDetail.isVisible = true
    },
    hideStatDetail() {
      this.statDetail.isVisible = false
    },
  },
  computed: {
    stats() {
      const format = stat => ({
        value: stat.count || 0,
        title: stat.periodId || 0,
        detail: `${stat.count || 0} Clients`,
      })
      return {
        initiated:
          this.rawStats?.paymentInitiatedStatsMonth?.map(format) ||
          Array(31).fill(0),
        failed:
          this.rawStats?.paymentFailedStatsMonth?.map(format) ||
          Array(31).fill(0),
        done:
          this.rawStats?.paymentDoneStatsMonth?.map(format) ||
          Array(31).fill(0),
      }
    },
    maxValue() {
      return Math.max(
        ...this.statsValues.initiated,
        ...this.statsValues.failed,
        ...this.statsValues.done,
      )
    },
    statsValues() {
      return {
        initiated: this.stats.initiated.map(stat => stat.value || 0),
        failed: this.stats.failed.map(stat => stat.value || 0),
        done: this.stats.done.map(stat => stat.value || 0),
      }
    },
  },
})
</script>
